export default __webpack_public_path__ + "static/media/ic-location.4895efcd.svg";